<template>
  <div class="frontpage-reference-rating-fieldset">
    <fieldset class="q-mt-md q-mb-lg">
      <p class="text-left text-body2 q-mb-sm">
        {{ $t("ETAB.REFERENCE.@RATING_TITLE", { name: candidateInformations.getFullName() }) }}
      </p>
      <div class="text-center">
        <QRating v-model="candidateProspect[ICandidateReferenceProspect.rating]" size="2em" :max="5" color="orange" icon-selected="star" no-reset>
          <template #tip-1>
            <QTooltip content-class="bg-primary" content-style="font-size: 16px" :offset="[10, 10]">
              {{ $t("ETAB.REFERENCE.@RATING_TOOLTIP_UNRECOMMANDED") }}
            </QTooltip>
          </template>
          <template #tip-2>
            <QTooltip content-class="bg-primary" content-style="font-size: 16px" :offset="[10, 10]">
              {{ $t("ETAB.REFERENCE.@RATING_TOOLTIP_INSUFFICIENT") }}
            </QTooltip>
          </template>
          <template #tip-3>
            <QTooltip content-class="bg-primary" content-style="font-size: 16px" :offset="[10, 10]">
              {{ $t("ETAB.REFERENCE.@RATING_TOOLTIP_MEDIUM") }}
            </QTooltip>
          </template>
          <template #tip-4>
            <QTooltip content-class="bg-primary" content-style="font-size: 16px" :offset="[10, 10]">
              {{ $t("ETAB.REFERENCE.@RATING_TOOLTIP_GOOD") }}
            </QTooltip>
          </template>
          <template #tip-5>
            <QTooltip content-class="bg-primary" content-style="font-size: 16px" :offset="[10, 10]">
              {{ $t("ETAB.REFERENCE.@RATING_TOOLTIP_VERY_GOOD") }}
            </QTooltip>
          </template>
        </QRating>
      </div>
      <p class="mobile-screens text-center text-bold text-body2 q-mb-none">
        {{ displayRatingTooltip }}
      </p>
    </fieldset>
    <fieldset>
      <p class="text-left text-body2">
        {{ $t("ETAB.REFERENCE.@COMMENT_TITLE") }}
      </p>
      <Field
        v-slot="{ errors, field, value }"
        v-model="candidateProspect[ICandidateReferenceProspect.comment]"
        tag="div"
        :name="$t('ETAB.REFERENCE.LABELS.@COMMENT_LABEL')"
        :rules="'required'"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          :name="$t('ETAB.REFERENCE.LABELS.@COMMENT_LABEL')"
          :placeholder="$t('ETAB.REFERENCE.@COMMENT_PLACEHOLDER')"
          :maxlength="MEDIUM_TEXT_LENGTH_LIMIT"
          counter
          type="textarea"
          filled
          :error="errors.length > 0"
          :error-message="errors[0]"
        />
      </Field>
    </fieldset>
  </div>
</template>

<script>
  import { ICandidateReferenceProspect, CandidateReferenceProspectModel, CandidateReferenceModel } from "@core/models";
  import { MEDIUM_TEXT_LENGTH_LIMIT } from "@core/constants";
  import { Field } from "vee-validate";

  export default {
    components: {
      Field,
    },
    props: {
      candidateProspect: {
        type: Object,
        default: () => new CandidateReferenceProspectModel(),
      },
      candidateInformations: {
        type: Object,
        default: () => new CandidateReferenceModel(),
      },
    },
    computed: {
      displayRatingTooltip() {
        const rating = this.candidateProspect[ICandidateReferenceProspect.rating];
        let tooltip = "";
        switch (rating) {
          case 1:
            tooltip = this.$t("ETAB.REFERENCE.@RATING_TOOLTIP_UNRECOMMANDED");
            break;
          case 2:
            tooltip = this.$t("ETAB.REFERENCE.@RATING_TOOLTIP_INSUFFICIENT");
            break;
          case 3:
            tooltip = this.$t("ETAB.REFERENCE.@RATING_TOOLTIP_MEDIUM");
            break;
          case 4:
            tooltip = this.$t("ETAB.REFERENCE.@RATING_TOOLTIP_GOOD");
            break;
          case 5:
            tooltip = this.$t("ETAB.REFERENCE.@RATING_TOOLTIP_VERY_GOOD");
            break;
          default:
            tooltip = "";
            break;
        }
        return tooltip;
      },
    },
    created() {
      this.ICandidateReferenceProspect = ICandidateReferenceProspect;
      this.MEDIUM_TEXT_LENGTH_LIMIT = MEDIUM_TEXT_LENGTH_LIMIT;
    },
  };
</script>
